export default __webpack_public_path__ + "static/category_test-9ec6393d4c50f789a379db43b02c4e4d.jpeg";